import Quill from 'quill'

let Embed = Quill.import('blots/embed')
// import VariableHelpers from '@/assets/js/variableHelpers.js'
import EventBus from '@/assets/js/eventBus.js'
import Store from '@/store/store.js'

// a simple blot to represent an editor method.
class MethodBlot extends Embed {
	static create(method) {
        let node = super.create()
    
        // node.innerText = ':'+ method.values.substr(1, method.values.indexOf('(') -1)
        node.innerText =  method.values.substr(1, method.values.indexOf('(') -1)
        node.setAttribute('title', method.values)
        node.setAttribute('value',  method.values)
        node.setAttribute('methodType',  method.values.substr(1, method.values.indexOf('(')))
		node.classList.add('method-blot')
		node.addEventListener('click', event => {
			// Store.dispatch('methodClicked', { node, method, event })
			EventBus.$emit('methodClicked', { node, method, event })
        })
        // console.log(node)
		return node
	}

		//Goes to delta.attributes
		static formats(node) {
			return {
				values: node.getAttribute('value'),
				methodType: node.getAttribute('methodType'),
			}
		}
		
		//Goes to delta.insert
		static value(node) {
            return {
                values: node.getAttribute('value'),
                methodType: node.getAttribute('methodType'),
			
		}
	}

}

MethodBlot.blotName = 'method'
MethodBlot.tagName = 'span'
MethodBlot.className = 'method-blot-class'

export default MethodBlot
